var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"d-flex flex-column align-items-start justify-content-start"},[_c('h1',[_vm._v("There is some magic stuff in this shop, and it's worth buying.")]),_c('br'),_c('h2',[_vm._v("Magic-shop official website")])])])
}]

export { render, staticRenderFns }